





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class App extends Vue {
	@Prop()
	private mediaInfoMap!: any

	@Prop()
	private needPlaceholder!: any

	@Prop()
	private list!: any

	@Prop()
	private picName!: any

	@Prop({ default: false })
	private bottomName!: boolean

	private getURL(url: any) {
		if (url) {
			return url + '?imageMogr2/thumbnail/192x'
		} else {
			return ''
		}
	}
}
